const options = {
    pin: 0,
    unpin: 0,
    tolerance: 5,
};
export default options;



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mhead-js/dist/core/_options.js
// module id = 96
// module chunks = 0